export interface Currency {
  code: string;
  symbol: string;
  name: string;
  region: string;
  isZeroDecimal?: boolean;
}

// Popular currencies that are commonly used
export const POPULAR_CURRENCY_CODES = [
  "USD",
  "EUR",
  "GBP",
  "JPY",
  "AUD",
  "CAD",
  "CHF",
  "CNY",
  "INR",
  "BRL",
];

// All currencies supported by Stripe - sorted alphabetically by name
export const CURRENCIES: Currency[] = [
  { code: "AFN", symbol: "؋", name: "Afghan Afghani", region: "Asia" },
  { code: "ALL", symbol: "L", name: "Albanian Lek", region: "Europe" },
  { code: "DZD", symbol: "د.ج", name: "Algerian Dinar", region: "Africa" },
  {
    code: "USD",
    symbol: "$",
    name: "American Dollar",
    region: "North America",
  },
  { code: "AOA", symbol: "Kz", name: "Angolan Kwanza", region: "Africa" },
  { code: "ARS", symbol: "$", name: "Argentine Peso", region: "South America" },
  { code: "AMD", symbol: "֏", name: "Armenian Dram", region: "Asia" },
  { code: "AWG", symbol: "ƒ", name: "Aruban Florin", region: "North America" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar", region: "Oceania" },
  { code: "AZN", symbol: "₼", name: "Azerbaijani Manat", region: "Asia" },
  {
    code: "BSD",
    symbol: "$",
    name: "Bahamian Dollar",
    region: "North America",
  },
  { code: "BHD", symbol: "د.ب", name: "Bahraini Dinar", region: "Asia" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka", region: "Asia" },
  {
    code: "BBD",
    symbol: "$",
    name: "Barbados Dollar",
    region: "North America",
  },
  { code: "BYN", symbol: "Br", name: "Belarusian Ruble", region: "Europe" },
  { code: "BZD", symbol: "$", name: "Belize Dollar", region: "North America" },
  {
    code: "BMD",
    symbol: "$",
    name: "Bermudian Dollar",
    region: "North America",
  },
  { code: "BTN", symbol: "Nu.", name: "Bhutanese Ngultrum", region: "Asia" },
  {
    code: "BOB",
    symbol: "Bs",
    name: "Bolivian Boliviano",
    region: "South America",
  },
  {
    code: "BAM",
    symbol: "КМ",
    name: "Bosnia-Herzegovina Convertible Mark",
    region: "Europe",
  },
  { code: "BWP", symbol: "P", name: "Botswana Pula", region: "Africa" },
  {
    code: "BRL",
    symbol: "R$",
    name: "Brazilian Real",
    region: "South America",
  },
  { code: "GBP", symbol: "£", name: "British Pound", region: "Europe" },
  { code: "BND", symbol: "B$", name: "Brunei Dollar", region: "Asia" },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev", region: "Europe" },
  {
    code: "BIF",
    symbol: "FBu",
    name: "Burundian Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "KHR", symbol: "៛", name: "Cambodian Riel", region: "Asia" },
  {
    code: "CAD",
    symbol: "C$",
    name: "Canadian Dollar",
    region: "North America",
  },
  { code: "CVE", symbol: "$", name: "Cape Verdean Escudo", region: "Africa" },
  {
    code: "KYD",
    symbol: "$",
    name: "Cayman Islands Dollar",
    region: "North America",
  },
  {
    code: "XAF",
    symbol: "FCFA",
    name: "Central African CFA Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  {
    code: "CLP",
    symbol: "$",
    name: "Chilean Peso",
    region: "South America",
    isZeroDecimal: true,
  },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan", region: "Asia" },
  { code: "COP", symbol: "$", name: "Colombian Peso", region: "South America" },
  {
    code: "KMF",
    symbol: "CF",
    name: "Comorian Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "CDF", symbol: "FC", name: "Congolese Franc", region: "Africa" },
  {
    code: "CRC",
    symbol: "₡",
    name: "Costa Rican Colón",
    region: "North America",
  },
  { code: "HRK", symbol: "kn", name: "Croatian Kuna", region: "Europe" },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna", region: "Europe" },
  { code: "DKK", symbol: "kr", name: "Danish Krone", region: "Europe" },
  {
    code: "DJF",
    symbol: "Fdj",
    name: "Djiboutian Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "DOP", symbol: "$", name: "Dominican Peso", region: "North America" },
  {
    code: "XCD",
    symbol: "$",
    name: "East Caribbean Dollar",
    region: "North America",
  },
  { code: "EGP", symbol: "£", name: "Egyptian Pound", region: "Africa" },
  { code: "ERN", symbol: "Nfk", name: "Eritrean Nakfa", region: "Africa" },
  { code: "ETB", symbol: "Br", name: "Ethiopian Birr", region: "Africa" },
  { code: "EUR", symbol: "€", name: "Euro", region: "Europe" },
  {
    code: "FKP",
    symbol: "£",
    name: "Falkland Islands Pound",
    region: "South America",
  },
  { code: "FJD", symbol: "FJ$", name: "Fijian Dollar", region: "Oceania" },
  { code: "GMD", symbol: "D", name: "Gambian Dalasi", region: "Africa" },
  { code: "GEL", symbol: "₾", name: "Georgian Lari", region: "Asia" },
  { code: "GHS", symbol: "GH₵", name: "Ghanaian Cedi", region: "Africa" },
  { code: "GIP", symbol: "£", name: "Gibraltar Pound", region: "Europe" },
  {
    code: "GTQ",
    symbol: "Q",
    name: "Guatemalan Quetzal",
    region: "North America",
  },
  {
    code: "GNF",
    symbol: "FG",
    name: "Guinean Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  {
    code: "GYD",
    symbol: "$",
    name: "Guyanese Dollar",
    region: "South America",
  },
  { code: "HTG", symbol: "G", name: "Haitian Gourde", region: "North America" },
  {
    code: "HNL",
    symbol: "L",
    name: "Honduran Lempira",
    region: "North America",
  },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar", region: "Asia" },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint", region: "Europe" },
  { code: "ISK", symbol: "kr", name: "Icelandic Króna", region: "Europe" },
  { code: "INR", symbol: "₹", name: "Indian Rupee", region: "Asia" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah", region: "Asia" },
  { code: "ILS", symbol: "₪", name: "Israeli New Shekel", region: "Asia" },
  {
    code: "JMD",
    symbol: "$",
    name: "Jamaican Dollar",
    region: "North America",
  },
  {
    code: "JPY",
    symbol: "¥",
    name: "Japanese Yen",
    region: "Asia",
    isZeroDecimal: true,
  },
  { code: "JOD", symbol: "د.ا", name: "Jordanian Dinar", region: "Asia" },
  { code: "KZT", symbol: "₸", name: "Kazakhstani Tenge", region: "Asia" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling", region: "Africa" },
  {
    code: "KRW",
    symbol: "₩",
    name: "Korean Won",
    region: "Asia",
    isZeroDecimal: true,
  },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar", region: "Asia" },
  { code: "KGS", symbol: "лв", name: "Kyrgystani Som", region: "Asia" },
  { code: "LAK", symbol: "₭", name: "Lao Kip", region: "Asia" },
  { code: "LBP", symbol: "ل.ل", name: "Lebanese Pound", region: "Asia" },
  { code: "LSL", symbol: "M", name: "Lesotho Loti", region: "Africa" },
  { code: "LRD", symbol: "$", name: "Liberian Dollar", region: "Africa" },
  { code: "LYD", symbol: "ل.د", name: "Libyan Dinar", region: "Africa" },
  { code: "MOP", symbol: "MOP$", name: "Macanese Pataca", region: "Asia" },
  { code: "MKD", symbol: "ден", name: "Macedonian Denar", region: "Europe" },
  {
    code: "MGA",
    symbol: "Ar",
    name: "Malagasy Ariary",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "MWK", symbol: "MK", name: "Malawian Kwacha", region: "Africa" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit", region: "Asia" },
  { code: "MVR", symbol: "Rf", name: "Maldivian Rufiyaa", region: "Asia" },
  { code: "MUR", symbol: "₨", name: "Mauritian Rupee", region: "Africa" },
  { code: "MXN", symbol: "$", name: "Mexican Peso", region: "North America" },
  { code: "MDL", symbol: "L", name: "Moldovan Leu", region: "Europe" },
  { code: "MNT", symbol: "₮", name: "Mongolian Tugrik", region: "Asia" },
  { code: "MAD", symbol: "د.م.", name: "Moroccan Dirham", region: "Africa" },
  { code: "MZN", symbol: "MT", name: "Mozambican Metical", region: "Africa" },
  { code: "MMK", symbol: "K", name: "Myanmar Kyat", region: "Asia" },
  { code: "NAD", symbol: "$", name: "Namibian Dollar", region: "Africa" },
  { code: "NPR", symbol: "₨", name: "Nepalese Rupee", region: "Asia" },
  {
    code: "ANG",
    symbol: "ƒ",
    name: "Netherlands Antillean Guilder",
    region: "North America",
  },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar", region: "Oceania" },
  {
    code: "NIO",
    symbol: "C$",
    name: "Nicaraguan Córdoba",
    region: "North America",
  },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira", region: "Africa" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone", region: "Europe" },
  { code: "OMR", symbol: "﷼", name: "Omani Rial", region: "Asia" },
  { code: "PKR", symbol: "₨", name: "Pakistani Rupee", region: "Asia" },
  {
    code: "PAB",
    symbol: "B/.",
    name: "Panamanian Balboa",
    region: "North America",
  },
  {
    code: "PGK",
    symbol: "K",
    name: "Papua New Guinean Kina",
    region: "Oceania",
  },
  {
    code: "PYG",
    symbol: "Gs",
    name: "Paraguayan Guaraní",
    region: "South America",
    isZeroDecimal: true,
  },
  { code: "PEN", symbol: "S/", name: "Peruvian Sol", region: "South America" },
  { code: "PHP", symbol: "₱", name: "Philippine Peso", region: "Asia" },
  { code: "PLN", symbol: "zł", name: "Polish Złoty", region: "Europe" },
  { code: "QAR", symbol: "﷼", name: "Qatari Riyal", region: "Asia" },
  { code: "RON", symbol: "lei", name: "Romanian Leu", region: "Europe" },
  { code: "RUB", symbol: "₽", name: "Russian Ruble", region: "Europe" },
  {
    code: "RWF",
    symbol: "RF",
    name: "Rwandan Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "SHP", symbol: "£", name: "Saint Helena Pound", region: "Africa" },
  { code: "WST", symbol: "WS$", name: "Samoan Tala", region: "Oceania" },
  {
    code: "STD",
    symbol: "Db",
    name: "São Tomé and Príncipe Dobra",
    region: "Africa",
  },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal", region: "Asia" },
  { code: "RSD", symbol: "дин", name: "Serbian Dinar", region: "Europe" },
  { code: "SCR", symbol: "₨", name: "Seychellois Rupee", region: "Africa" },
  { code: "SLE", symbol: "Le", name: "Sierra Leonean Leone", region: "Africa" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar", region: "Asia" },
  {
    code: "SBD",
    symbol: "SI$",
    name: "Solomon Islands Dollar",
    region: "Oceania",
  },
  { code: "SOS", symbol: "S", name: "Somali Shilling", region: "Africa" },
  { code: "ZAR", symbol: "R", name: "South African Rand", region: "Africa" },
  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee", region: "Asia" },
  {
    code: "SRD",
    symbol: "$",
    name: "Surinamese Dollar",
    region: "South America",
  },
  { code: "SZL", symbol: "E", name: "Swazi Lilangeni", region: "Africa" },
  { code: "SEK", symbol: "kr", name: "Swedish Krona", region: "Europe" },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc", region: "Europe" },
  { code: "TJS", symbol: "SM", name: "Tajikistani Somoni", region: "Asia" },
  { code: "TZS", symbol: "TSh", name: "Tanzanian Shilling", region: "Africa" },
  { code: "THB", symbol: "฿", name: "Thai Baht", region: "Asia" },
  { code: "TOP", symbol: "T$", name: "Tongan Paʻanga", region: "Oceania" },
  {
    code: "TTD",
    symbol: "TT$",
    name: "Trinidad and Tobago Dollar",
    region: "North America",
  },
  { code: "TND", symbol: "د.ت", name: "Tunisian Dinar", region: "Africa" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira", region: "Europe" },
  { code: "TWD", symbol: "NT$", name: "Taiwan Dollar", region: "Asia" },
  {
    code: "UGX",
    symbol: "USh",
    name: "Ugandan Shilling",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia", region: "Europe" },
  {
    code: "AED",
    symbol: "د.إ",
    name: "United Arab Emirates Dirham",
    region: "Asia",
  },
  {
    code: "UYU",
    symbol: "$U",
    name: "Uruguayan Peso",
    region: "South America",
  },
  { code: "UZS", symbol: "лв", name: "Uzbekistani Som", region: "Asia" },
  {
    code: "VUV",
    symbol: "VT",
    name: "Vanuatu Vatu",
    region: "Oceania",
    isZeroDecimal: true,
  },
  {
    code: "VND",
    symbol: "₫",
    name: "Vietnamese Dong",
    region: "Asia",
    isZeroDecimal: true,
  },
  {
    code: "XOF",
    symbol: "CFA",
    name: "West African CFA Franc",
    region: "Africa",
    isZeroDecimal: true,
  },
  { code: "YER", symbol: "﷼", name: "Yemeni Rial", region: "Asia" },
  { code: "ZMW", symbol: "ZK", name: "Zambian Kwacha", region: "Africa" },
];

export const getCurrencyByCode = (code: string): Currency | undefined => {
  return CURRENCIES.find((currency) => currency.code === code.toUpperCase());
};

export const getCurrenciesByRegion = (region: string): Currency[] => {
  return CURRENCIES.filter((currency) => currency.region === region);
};

export const getPopularCurrencies = (): Currency[] => {
  return CURRENCIES.filter((currency) =>
    POPULAR_CURRENCY_CODES.includes(currency.code),
  );
};
export const getOtherCurrencies = (): Currency[] => {
  return CURRENCIES.filter(
    (currency) => !POPULAR_CURRENCY_CODES.includes(currency.code),
  );
};

export const getCurrenciesList = (): Currency[] => {
  return [...getPopularCurrencies(), ...getOtherCurrencies()];
};

export const getAllRegions = (): string[] => {
  const regions = new Set(CURRENCIES.map((currency) => currency.region));
  return Array.from(regions).sort();
};

/**
 * Calculates the Stripe amount based on currency decimal handling
 * Zero-decimal currencies (like JPY, KRW) don't need multiplication by 100
 * Two-decimal currencies (like USD, EUR) need multiplication by 100
 *
 * @param amount - The amount to process
 * @param currencyCode - The currency code (e.g., 'USD', 'JPY')
 * @returns The amount formatted for Stripe API
 */
export const calculateStripeAmount = (
  amount: number,
  currencyCode: string,
): number => {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.isZeroDecimal
    ? Math.round(amount)
    : Math.round(amount * 100);
};

export function stripeAmountToPrice(amount: number) {
  return amount / 100;
}

/**
 * Formats a price with currency, handling free prices.
 * Server-side utility for formatting prices in server components.
 *
 * @param price - The price to format
 * @param currency - The currency code (e.g., 'USD', 'EUR')
 * @returns Formatted price string or "Free" if price is 0
 */
export async function formatPrice(
  price: number,
  currency: string,
): Promise<string> {
  const { getFormatter, getTranslations } = await import("next-intl/server");
  const format = await getFormatter();
  const t = await getTranslations("PriceFormatter");

  if (price === 0) {
    return t("free");
  }

  return format.number(price, "currency", {
    currency: currency,
  });
}
